"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
function lazyWithPreload(factory) {
    var LazyComponent = react_1.lazy(factory);
    var factoryPromise;
    var LoadedComponent;
    var Component = react_1.forwardRef(function LazyWithPreload(props, ref) {
        return react_1.createElement(LoadedComponent !== null && LoadedComponent !== void 0 ? LoadedComponent : LazyComponent, Object.assign(ref ? { ref: ref } : {}, props));
    });
    Component.preload = function () {
        if (!factoryPromise) {
            factoryPromise = factory().then(function (module) {
                LoadedComponent = module.default;
            });
        }
        return factoryPromise;
    };
    return Component;
}
exports.default = lazyWithPreload;
